const commonActionTypes = {
    SET_TIME_ZONE: 'SET_TIME_ZONE',
    SET_SECURITY: 'SET_SECURITY',
    SET_USER_ID: 'SET_USER_ID',
    SET_SHOW_OI_PROFLIE: 'SET_SHOW_OI_PROFLIE',
    TOGGLE_THEME: 'TOGGLE_THEME',
    SET_THEME_MODE: 'SET_THEME_MODE',
    SAVE_SECURITY_SNAPSHOT: 'SAVE_SECURITY_SNAPSHOT',
    SET_RIGHT_SIDE_WIDGET: 'SET_RIGHT_SIDE_WIDGET',
    SAVE_OPTION_SELECTED_COLUMN: 'SAVE_OPTION_SELECTED_COLUMN',
    SET_CHARTS_META_DATA: 'SET_CHARTS_META_DATA',
    SET_SELECTECED_WATCHLIST_ID: 'SET_SELECTECED_WATCHLIST_ID',
    SHOW_OVERVIEW_CHART: 'SHOW_OVERVIEW_CHART',
    SET_OVERVIEW_INDEX_COMPONENTS_SORTED_BY: 'SET_OVERVIEW_INDEX_COMPONENTS_SORTED_BY',
    VOLUME_INDICATOR_REMOVED: 'VOLUME_INDICATOR_REMOVED',
    SAVE_OVERVIEW_SECURITY_SNAPSHOT: 'SAVE_OVERVIEW_SECURITY_SNAPSHOT',
    RESET_INITIAL_STATE: 'RESET_INITIAL_STATE',
    SET_BROKER_LOGIN_TYPE: 'SET_BROKER_LOGIN_TYPE',
    SET_TRADING_ACCOUNTS: 'SET_TRADING_ACCOUNTS',
    SET_API_ERROR: 'SET_API_ERROR',
    SAVE_SCREENER_SELECTED_COLUMN_SET: 'SAVE_SCREENER_SELECTED_COLUMN_SET',
    SET_FRESH_TOKEN: 'SET_FRESH_TOKEN',
    SET_PREV_URL: 'SET_PREV_URL',
    SAVE_INTO_RECENT_EXPRESSIONS: 'SAVE_INTO_RECENT_EXPRESSIONS',
    DELETE_RECENT_EXPRESSION: 'DELETE_RECENT_EXPRESSION',
    SAVE_RECENT_EXPRESSIONS_REFRESHED_TIME: 'SAVE_RECENT_EXPRESSIONS_REFRESHED_TIME',
    SET_BROKERS: 'SET_BROKERS',
    ADD_OR_UPDATE_STRATEGY_EXPRESSION_METADATA: 'ADD_OR_UPDATE_STRATEGY_EXPRESSION_METADATA',
    SET_NAVIGATION_URL: 'SET_NAVIGATION_URL',
    MULTI_PANE_FULLSCREEN: 'MULTI_PANE_FULLSCREEN',
    SET_WIDGETS_PANE_ID: 'SET_WIDGETS_PANE_ID',
    TOGGLE_FULLSCREEN: 'TOGGLE_FULLSCREEN',
    RESET_WIDGET_FULLSCREEN: 'RESET_WIDGET_FULLSCREEN',
    SET_OPTION_CHAIN_VISIBLE_STRIKES: 'SET_OPTION_CHAIN_VISIBLE_STRIKES',
    SET_OPTION_CHAIN_TABLE_VIEW: 'SET_OPTION_CHAIN_TABLE_VIEW',
    SET_OPTION_CHAIN_QUANTITY_IN_LOTS: 'SET_OPTION_CHAIN_QUANTITY_IN_LOTS',
    SET_OPTION_CHAIN_TIMEBUCKET: 'SET_OPTION_CHAIN_TIMEBUCKET',
    SET_OPTION_CHAIN_MIRROR_SCROLL: 'SET_OPTION_CHAIN_MIRROR_SCROLL',
    SET_NEWS_CATEGORY: 'SET_NEWS_CATEGORY',
    ADD_CUSTOM_COLOR: 'ADD_CUSTOM_COLOR',
    UPDATE_MARKET_DEPTH_SECURITY: 'UPDATE_MARKET_DEPTH_SECURITY',
    SET_CALENDAR_WEEK_CARDS_EXPANDED: 'SET_CALENDAR_WEEK_CARDS_EXPANDED',
}

export default commonActionTypes